import React from "react";
import type {HistoryAttempt, HistoryReceipt} from "../types";
import {formatDate} from "../utils";

/**
 * attemptReceipts — чеки попытки в порядке оплаты.
 *
 * Список появился вместе с В-23: трейдер может закрыть свою часть заявки
 * несколькими переводами и приложить к одному платежу несколько чеков. Старый
 * ответ нёс ровно одну ссылку, и карточка с пятью переводами читалась как
 * «прислан один чек», хотя площадка и мерчант получили все пять.
 *
 * Одиночные `receiptUrl`/`receiptUploadedAt` остались в ответе и указывают на
 * последний чек. Читаем их только если списка нет вовсе — это ответ бэкенда,
 * поднятого до этой правки.
 */
export function attemptReceipts(attempt: HistoryAttempt): HistoryReceipt[] {
    if (attempt.receipts && attempt.receipts.length > 0) return attempt.receipts;
    if (!attempt.receiptUrl) return [];
    return [{
        receiptId: attempt.paymentId,
        receiptUrl: attempt.receiptUrl,
        uploadedAt: attempt.receiptUploadedAt ?? "",
    }];
}

/**
 * AttemptReceipts — ячейка «Чек» в таблице попыток.
 *
 * Один чек показывается как раньше — словом «чек». Несколько нумеруются, чтобы
 * по карточке было видно, сколькими переводами закрыт платёж.
 */
export function AttemptReceipts({
    attempt,
    onDownload,
}: {
    attempt: HistoryAttempt;
    onDownload: (receipt: HistoryReceipt) => void;
}): JSX.Element {
    const receipts = attemptReceipts(attempt);
    if (receipts.length === 0) return <span className="muted">—</span>;
    return (
        <span className="attempt-receipts">
            {receipts.map((receipt, index) => (
                <a
                    key={receipt.receiptId}
                    href={receipt.receiptUrl ?? "#"}
                    target="_blank"
                    rel="noreferrer"
                    title={receipt.uploadedAt ? formatDate(receipt.uploadedAt) : undefined}
                    onClick={(event) => {
                        event.preventDefault();
                        onDownload(receipt);
                    }}
                >
                    {receipts.length > 1 ? `чек ${index + 1}` : "чек"}
                </a>
            ))}
        </span>
    );
}
